import React from "react";
import Dialog from "../../../../common/element/Dialog";

const AssignmentResult = ({ 
  dialogOpen = false, 
  onDialogClose = () => {}, 
  AssignmentData = [], 
  assignmentName = "" 
}) => {
  // Ensure AssignmentData is always an array
  const questions = Array.isArray(AssignmentData) ? AssignmentData : [];

  return (
    <Dialog
      isOpen={dialogOpen}
      onClose={onDialogClose}
      onRequestClose={onDialogClose}
      width={700}
      bodyOpenClassName="overflow-hidden"
      closeOnOverlayClick={true}
    >
      {/* Header */}
      <div className="flex border-b px-6 py-4 items-center justify-between">
        <div className="flex items-center">
          <span className="h-10 w-10 border rounded-lg border-gray-200 flex items-center justify-center shadow-sm mr-3">
            <svg
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4 4H20V20H4V4ZM8 8H16M8 12H16M8 16H12"
                stroke="#344054"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
          <h5 className="text-gray-900 text-lg font-semibold">
            View Assignment
          </h5>
        </div>

        <button
          onClick={onDialogClose}
          className="text-gray-400 hover:text-gray-600"
        >
          <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18 6L6 18M6 6l12 12"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>

      {/* Title Section */}
      <div className="px-6 pt-5 pb-4 bg-white">
        <h3 className="text-gray-900 text-base font-semibold">
          {assignmentName || "Assignment Details"}
        </h3>
      </div>

      {/* Body - Questions List */}
      <div className="px-6 pb-5 overflow-y-auto flex-1 max-h-[400px]">
        <div className="space-y-4">
          {questions.length > 0 ? (
            questions.map((item, index) => (
              <div
                key={item?.question_id ?? item?.id ?? index}
                className="border-b border-gray-100 pb-4 last:border-b-0"
              >
                <div className="mb-2">
                  <span className="text-gray-900 text-sm font-medium">
                    Q{index + 1}.
                  </span>
                  <span className="text-gray-900 text-sm ml-1">
                    {item?.question_text || item?.question || "No question text available"}
                  </span>
                </div>
                
                {/* Optional: Show question type if available */}
                {item?.question_type && (
                  <div className="mt-1">
                    <span className="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded">
                      Type: {item.question_type}
                    </span>
                  </div>
                )}
              </div>
            ))
          ) : (
            <div className="py-8 text-center text-gray-500">
              No questions available for this assignment
            </div>
          )}
        </div>
      </div>

      {/* Footer */}
      <div className="flex justify-end border-t px-6 py-4">
        <button
          className="whiteBtnShadow btn border border-gray-100 rounded-lg h-10 px-5 bg-[#FFF4E5] text-gray-700 text-sm font-semibold hover:bg-[#FFE4CC] transition-colors duration-100"
          onClick={onDialogClose}
        >
          Close
        </button>
      </div>
    </Dialog>
  );
};

export default AssignmentResult;